import { z } from "zod";
/**
 * Zod schemas for the Conversations module — the unified inbox that
 * surfaces email, WhatsApp, and (later) SMS under one shape.
 *
 * Phase A scope: shapes only, no API routes wired yet. Phase B
 * (inbound WhatsApp) writes the first conversations; later phases
 * extend.
 *
 * Canon: docs/enhancements/whatsapp-2026-05.md.
 */
export const ConversationChannelSchema = z.enum(["whatsapp", "email", "sms"]);
export const ConversationStateSchema = z.enum(["open", "snoozed", "closed"]);
export const MessageDirectionSchema = z.enum(["inbound", "outbound"]);
export const MessageStatusSchema = z.enum(["queued", "sent", "delivered", "read", "failed"]);
export const ConversationSchema = z.object({
    id: z.string().uuid(),
    contactId: z.string().uuid().nullable(),
    channel: ConversationChannelSchema,
    state: ConversationStateSchema,
    lastInboundAt: z.string().datetime().nullable(),
    lastOutboundAt: z.string().datetime().nullable(),
    unreadCount: z.number().int().nonnegative(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ConversationMessageSchema = z.object({
    id: z.string().uuid(),
    conversationId: z.string().uuid(),
    direction: MessageDirectionSchema,
    body: z.string(),
    attachments: z.array(z.unknown()),
    templateId: z.string().uuid().nullable(),
    templateVariables: z.record(z.string(), z.unknown()).nullable(),
    providerMessageId: z.string().nullable(),
    status: MessageStatusSchema,
    failureReason: z.string().nullable(),
    sentAt: z.string().datetime().nullable(),
    deliveredAt: z.string().datetime().nullable(),
    readAt: z.string().datetime().nullable(),
    senderEmail: z.string().email().nullable(),
    createdAt: z.string().datetime(),
});
export const WhatsAppTemplateCategorySchema = z.enum(["MARKETING", "UTILITY", "AUTHENTICATION"]);
export const WhatsAppTemplateStatusSchema = z.enum(["PENDING", "APPROVED", "REJECTED", "DISABLED"]);
export const WhatsAppTemplateSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(200),
    language: z.string().min(2).max(10),
    category: WhatsAppTemplateCategorySchema,
    status: WhatsAppTemplateStatusSchema,
    body: z.string(),
    variables: z.array(z.unknown()),
    metaTemplateId: z.string().nullable(),
    lastSyncedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=conversations.js.map